import { render, staticRenderFns } from "./COD-Bank-Ckeckout.vue?vue&type=template&id=f5ac93a8&scoped=true&"
import script from "./COD-Bank-Ckeckout.vue?vue&type=script&lang=js&"
export * from "./COD-Bank-Ckeckout.vue?vue&type=script&lang=js&"
import style0 from "./COD-Bank-Ckeckout.vue?vue&type=style&index=0&id=f5ac93a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ac93a8",
  null
  
)

export default component.exports